export const DEFAULT_PROFILES_PAGE = 1;
export const DEFAULT_PROFILES_PAGE_SIZE = 10;
export const AUCTION_SNAPSHOT_TABLE_DEFAULT_PAGE = 0;
export const AUCTION_SNAPSHOT_TABLE_DEFAULT_PAGE_SIZE = 10;
export const SNAPSHOT_NAME_MAX_LENGTH = 255;
export const PROFILE_NAME_MAX_LENGTH = 255;
export const INPUT_VALUE_MAX_LENGTH = 50;

export const MY_PROFILES_FILTER = 'my';
export const OTHER_PROFILES_FILTER = 'other';

export const DEBOUNCE_DELAY = 300;

export const USER_OPTIONS_ALL = 'all';

export const MY_SNAPSHOTS = 'My Snapshots';
export const ALL_SNAPSHOTS = 'All Snapshots';

const REQUIRED_POPULATED_LABEL = '(Required if populated)';

export const FORM_FIELDS = {
  SNAPSHOT_NAME: {
    label: 'Snapshot Name',
    name: 'snapshotName',
  },
  USER_PROFILE: {
    label: `Selected ID ${REQUIRED_POPULATED_LABEL}`,
    name: 'userProfile',
  },
  SUPPLY_SOURCE: {
    label: 'Supply Source',
    name: 'supplySource',
  },
  ADVERTISER: {
    label: 'Advertiser (adomain)',
    name: 'advertiser',
  },
  CREATIVE_ID: {
    label: `DSP : CRID ${REQUIRED_POPULATED_LABEL}`,
    name: 'creativeId',
  },
  INPUT_VALUE: {
    label: `Device ID / Profile ID ${REQUIRED_POPULATED_LABEL}`,
    name: ['selectionSearch', 'inputValue'],
  },
  RESULT: {
    label: 'Result',
    name: 'result',
  },
  INVENTORY_TYPE: {
    label: 'Inventory Type',
    name: 'inventoryType',
  },
  APP_NAME: {
    label: 'Publisher',
    name: 'appName',
  },
  DEVICE_FAMILY: {
    label: 'Device Name',
    name: 'deviceFamily',
  },
  IFA_TYPE: {
    label: 'IFA Type',
    name: 'ifaType',
  },
  DOMAIN: {
    label: 'Domain',
    name: 'domain',
  },
  USER_AGENT: {
    label: 'User Agent',
    name: 'userAgent',
  },
  LIMITED_AD_TRACKING: {
    label: 'Limited Ad Tracking',
    name: 'dnt',
  },
  CHANNEL: {
    label: 'Channel',
    name: 'channel',
  },
  SERIES: {
    label: 'Series',
    name: 'series',
  },
  CONTENT_PARTNER: {
    label: 'Content Partner ID',
    name: 'contentPartner',
  },
  CONTENT_PARTNER_PARENT_ID: {
    label: 'Content Partner Parent ID',
    name: 'contentPartnerParentId',
  },
  VDM: {
    label: 'PlayBack Type',
    name: 'vdm',
  },
  CREATIVE_DURATION: {
    label: 'Creative Duration',
    name: 'creativeDuration',
  },
  MEDIA_FILE_URL: {
    label: 'Media File URL',
    name: 'mediaFileUrl',
  },
  WINNING_AUCTION: {
    label: 'Winning Demand Partner',
    name: 'winningAuction',
  },
  AD_PARTNER_DSP: {
    label: 'DSP (Magnite)',
    name: 'adPartnerDsp',
  },
  RECEIVED_BID_DEAL_ID: {
    label: 'Received bid with Specific Deal Type',
    name: 'receivedBidDealId',
  },
  TIME_ALLOWED: {
    label: 'Time Allowed before Stop Running',
    name: 'timeAllowedBeforeStopRunning',
  },
  SESSION_ID: {
    label: `Session ID ${REQUIRED_POPULATED_LABEL}`,
    name: 'sessionId',
  },
  BRAND: {
    label: 'Brand',
    name: 'brand',
  },
  FORM_FACTOR: {
    label: 'Form-Factor',
    name: 'formFactor',
  },
  DEVICE_CATEGORY: {
    label: 'Device Category',
    name: 'deviceCategory',
  },
  DISTRIBUTOR: {
    label: 'Distributor',
    name: 'distributor',
  },
  SELECT_TYPE: {
    label: 'ID Type',
    name: ['selectionSearch', 'selectType'],
  },
  SELECT_ID: {
    label: `Selected ID ${REQUIRED_POPULATED_LABEL}`,
    name: 'selectedId',
  },
  SUPPLY_AD_UNIT_ID: {
    label: 'Supply Ad Unit ID (UUID)',
    name: 'supplyAdUnitId',
  },
  SUPPLY_AD_UNIT_NAME: {
    label: 'Supply Ad Unit Name',
    name: 'supplyAdUnitName',
  },
  BUYER_DEAL_ID: {
    label: 'Deal ID (External)',
    name: 'externalDealId',
  },
  DEAL_NAME: {
    label: 'Deal Name',
    name: 'dealName',
  },
  SYSTEM_DEAL_ID: {
    label: 'System Deal ID (Internal)',
    name: 'internalDealId',
  },
  BUYER_SEAT_ID: {
    label: 'Buyer Seat ID',
    name: 'buyerSeatID',
  },
  PACKAGE_NAME: {
    label: 'Package Name',
    name: 'packageName',
  },
  CREATIVE_NAME: {
    label: 'Creative Name',
    name: 'creativeName',
  },
  BID_STATE: {
    label: 'Bid State',
    name: 'bidState',
  },
  COUNTRY: {
    label: 'Country',
    name: 'country',
  },
  POD: {
    label: 'Pod',
    name: 'pod',
  },
  GENRE: {
    label: 'Genre',
    name: 'genre',
  },
  RATING: {
    label: 'Rating',
    name: 'rating',
  },
  MAGIC_WORDS_SEARCH: {
    label: '',
    name: 'magicWordSearch',
  },
  MAGIC_WORDS_TYPE: {
    label: 'Magic Words',
    name: ['magicWordSearch', 'type'],
  },
  ALID_ID: {
    label: 'Alid ID',
    name: 'assetId',
  },
  ENTITY_ID: {
    label: 'Entity ID',
    name: 'entityId',
  },
  POD_POSITION: {
    label: 'Pod Position',
    name: 'podPosition',
  },
  ENTITY_TYPE: {
    label: 'Entity Type',
    name: 'entityType',
  },
  SPORTS_LEAGUE: {
    label: 'Sports League',
    name: 'sportsLeague',
  },
};

export const RESULT_OPTIONS = [
  { label: 'All', value: 'all' },
  { label: 'Ads Returned', value: 'ads' },
  { label: 'No Ads Returned', value: 'no_ads' },
];

export const LIMITED_AD_TRACKING_OPTIONS = [
  { label: 'No Preference', value: 'ALL' },
  { label: 'Enabled', value: 'ENABLED' },
  { label: 'Disabled', value: 'DISABLED' },
];

export const APP_INVENTORY_TYPE = 'App';
export const WEB_INVENTORY_TYPE = 'Web';

export const INVENTORY_TYPES = [
  { label: 'All', value: 'All' },
  { label: 'App', value: APP_INVENTORY_TYPE },
  { label: 'Web', value: WEB_INVENTORY_TYPE },
];
